import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=ea01a36e&scoped=true&lang=html&"
import script from "./SVGIcon.vue?vue&type=script&lang=js&"
export * from "./SVGIcon.vue?vue&type=script&lang=js&"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=ea01a36e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea01a36e",
  null
  
)

export default component.exports